import { Dispatch, SetStateAction } from 'react';
import Modal from '@/components/v2/common/Modal';
import { ComplianceInfoT } from '../constants';
import ComplianceHeader from './Header';
import ComplianceContent from './Content';

type ComplianceModalProps = {
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  info: ComplianceInfoT;
};

const ComplianceModal = ({
  showModal,
  setShowModal,
  info,
}: ComplianceModalProps) => (
  <Modal
    isOpen={showModal}
    onClose={() => setShowModal(false)}
    width="sm:max-w-[450px]"
  >
    <ComplianceHeader setShowModal={setShowModal} />
    <ComplianceContent info={info} />
  </Modal>
);

export default ComplianceModal;
